import classNames from "classnames/bind";

import styles from "./Input.module.scss";
const cx = classNames.bind(styles);

type FormInputProps = {
  name: string;
  type?: string;
  placeholder: string;
  className?: string;
  min?: number;
  max?: number;
  step?: number;
  value: string;
  tabIndex?: number;
  pattern?: string;
  required?: boolean;
  width?: "full" | "half" | "quarter";
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function FormInput({
  name,
  type,
  placeholder,
  className,
  value,
  onChange,
  tabIndex,
  required = true,
  width,
  pattern,
  min,
  max,
  step,
}: FormInputProps) {
  return (
    <div className={cx(["form-input", width, className])}>
      <label htmlFor={name} className={cx("tag-s", "form-eyebrow", { show: !!value })}>
        {placeholder}
      </label>
      <input
        className={cx("input", "text-m", { filled: !!value })}
        type={type ?? "text"}
        name={name}
        min={min}
        max={max}
        step={step}
        id={name}
        tabIndex={tabIndex}
        pattern={pattern}
        required={required}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
      />
    </div>
  );
}
